<header id="headadmin">
  <app-header></app-header>
  <!--app-navbar></app-navbar-->
</header>
<body>
  <div class="card">
    <div class="card-header" style="background-color: #be0c4d;">
      <h5 class="modal-title" id="exampleModalLabel" style="color: white;">Cambiar Contraseña</h5>
    </div>
    <div class="card-body">
      <div class="row justify-content-center">
        <div class="col-auto"><label>Contraseña actual</label></div>
      </div>
      <div class="row justify-content-center">
        <div class="col-6"><input type="password" class="form-control" name="contrasenaactual" [(ngModel)]="ContrasenaActual"></div>
      </div>
      <div class="row justify-content-center">
        <div class="col-auto"><label>Contraseña nueva</label></div>
      </div>
      <div class="row justify-content-center">
        <div class="col-6"><input type="password" class="form-control" name="contrasenaactual" [formControl]="PasswordNew"></div>
        <small *ngIf="PasswordNew.hasError('required') && PasswordNew.dirty">* El campo es requerido</small>
        <small *ngIf="PasswordNew.hasError('pattern') && PasswordNew.dirty">* La nueva contrseña debe tener mínimo de 8 caracteres, letras mayúsculas, letras minúsculas, números y símbolos</small>
      </div>
      <div class="row justify-content-center">
        <div class="col-auto"><label>Confirmar contraseña</label></div>
      </div>
      <div class="row justify-content-center">
        <div class="col-6"><input type="password" class="form-control" name="contrasenaactual" [(ngModel)]="ContrasenaConfirma"></div>
      </div>
      <br>
      <div class="card-footer">
        <div class="row justify-content-center">
          <button [disabled]="BtnCambiar || PasswordNew.invalid" type="button" class="btn btn-primary col-3" (click)="verificarContrasena()">Cambiar</button>
        </div>
      </div>
    </div>
  </div>
</body>

<!-- Modal Cambiar Contraseña-->
<!--button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#exampleModal" style="visibility: hidden;" #openModalContrasena>Launch static backdrop modal</button>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <form>
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h5 class="modal-title" id="exampleModalLabel" style="color: white;">Cambiar Contraseña</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">

          <div class="row justify-content-center">
            <div class="col-auto"><label>Contraseña actual</label></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6"><input type="password" class="form-control" name="contrasenaactual" [(ngModel)]="ContrasenaActual"></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-auto"><label>Contraseña nueva</label></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6"><input type="password" class="form-control" name="contrasenaactual" [formControl]="PasswordNew"></div>
            <small *ngIf="PasswordNew.hasError('required') && PasswordNew.dirty">El campo es requerido</small>
            <small *ngIf="PasswordNew.hasError('pattern') && PasswordNew.dirty">La nueva contrseña debe tener mínimo de 8 caracteres, letras mayúsculas, letras minúsculas, números y símbolos</small>
          </div>
          <div class="row justify-content-center">
            <div class="col-auto"><label>Confirmar contraseña</label></div>
          </div>
          <div class="row justify-content-center">
            <div class="col-6"><input type="password" class="form-control" name="contrasenaactual" [(ngModel)]="ContrasenaConfirma"></div>
          </div>

      </div>
      <div class="modal-footer justify-content-center">
        <button type="button" class="btn btn-secondary" #closeModalContrasena data-bs-dismiss="modal">Cancelar</button>
        <button [disabled]="BtnCambiar" type="submit" class="btn btn-primary" (click)="verificarContrasena()">Cambiar</button>  (click)="probando()" data-bs-dismiss="modal" [disabled]="PasswordNew.invalid"
      </div>
    </div>
    </form>
  </div>
</div-->

